import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type EULAState = {
  eulaAccepted: boolean;
  setAcceptEULA: (accept: boolean) => void;
  isEULAAccepted: () => boolean;
};

class NoopStorage implements Storage {
  length = 0;
  clear() {}
  getItem(_key: string) { return null; }
  key(_index: number) { return null; }
  removeItem(_key: string) {}
  setItem(_key: string, _value: string) {}
}

const storage = createJSONStorage<EULAState>(() => {
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }
  return new NoopStorage();
});

export const useEULAStore = create<EULAState>()(
  persist(
    (set, get) => ({
      eulaAccepted: false,

      setAcceptEULA: (accept) => set({ eulaAccepted: accept }),

      isEULAAccepted: () => get().eulaAccepted,
    }),
    {
      name: "eula-storage",
      storage,
    }
  )
);

// Optional convenience exports
export const getEULAAccepted = () => useEULAStore.getState().isEULAAccepted();
export const acceptEULA = (accept: boolean) => useEULAStore.getState().setAcceptEULA(accept);

export default useEULAStore;
